import { Icon } from '@iconify/react'
import clsx from 'clsx'
import { forwardRef } from 'react'

import type { InputProps } from '~/types/component'

const Input = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { type, size, icon, rounded, placeholder, disabled, isLoading, errorMessage, ...rest } = props

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (type === 'number') {
      // const currentValue = event.currentTarget.value
      // const cursorPosition = event.currentTarget.selectionStart || 0
      const key = event.key

      // if (currentValue === '0' && key === '0') {
      //   event.preventDefault()
      // }

      // if (currentValue.length === 0 && key === '0' && cursorPosition === 0) {
      //   event.preventDefault()
      // }

      if (
        (isNaN(Number(key)) || key === ' ') &&
        key !== 'Backspace' &&
        key !== 'Delete' &&
        key !== 'ArrowLeft' &&
        key !== 'ArrowRight' &&
        key !== 'Tab'
      ) {
        event.preventDefault()
      }
    }
  }

  // const handleInput = (event: React.FormEvent<HTMLInputElement>) => {
  //   if (type === 'number') {
  //     const currentValue = event.currentTarget.value

  //     if (currentValue.startsWith('0')) {
  //       event.currentTarget.value = currentValue.replace(/^0+/, '')
  //     }
  //   }
  // }

  return (
    <div className="relative w-full">
      <input
        ref={ref}
        type={type}
        className={clsx(
          'w-full border-0 bg-jba-gray text-jba-blue',
          [type === 'number' && 'number-input'],
          [!size && 'h-[42px] px-4 text-xs'],
          [size === 'large' && 'text-sm'],
          [size === 'small' && 'px-2 text-xs'],
          [rounded === 'xl' ? 'rounded-xl' : 'rounded-lg'],
          [
            errorMessage
              ? 'ring-1 ring-inset ring-jba-red placeholder:text-jba-red focus:ring-inset focus:ring-jba-red'
              : 'placeholder:text-gray-400 focus:ring-0',
          ],
          [icon && 'pl-10'],
        )}
        placeholder={placeholder}
        disabled={disabled}
        onKeyDown={handleKeyDown}
        // onInput={handleInput}
        {...rest}
      />
      {errorMessage && <span className="mt-4 text-xs text-jba-red">{errorMessage}</span>}
      {isLoading && (
        <Icon
          icon="material-symbols:progress-activity"
          className={clsx('absolute inset-y-0 right-2 my-auto shrink-0 animate-spin text-jba-blue', [
            size === 'large' ? 'text-xl' : 'text-lg',
          ])}
        />
      )}
      {icon && (
        <Icon
          icon={icon}
          className={clsx('absolute left-3 top-3 my-auto shrink-0 text-lg', [
            errorMessage ? 'text-jba-red' : 'text-jba-blue',
          ])}
        />
      )}
    </div>
  )
})

export default Input
